var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInput1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.243 0h35.514C38.996 0 40 .992 40 2.215v19.57C40 23.008 38.996 24 37.757 24H2.243C1.004 24 0 23.008 0 21.785V2.215C0 .992 1.004 0 2.243 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.005v19.99A1.5 1.5 0 0 0 1.997 23.5h36.006a1.5 1.5 0 0 0 1.497-1.505V2.005A1.5 1.5 0 0 0 38.003.5H1.997A1.5 1.5 0 0 0 .5 2.005zm-.5 0A2 2 0 0 1 1.997 0h36.006A2 2 0 0 1 40 2.005v19.99A2 2 0 0 1 38.003 24H1.997A2 2 0 0 1 0 21.995V2.005z",
    fill: "#BEC8D2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#537BB4",
    d: "M3.364 4.431h33.645v4.062H3.364zM31.028 13.292h5.981V19.2h-5.981zM3.364 13.292h19.813v1.846H3.364zM3.364 16.985h10.093v1.846H3.364z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput1);
export default __webpack_public_path__ + "static/media/input1.1e2912390bfadfa76ac8fc58e0e1844b.svg";
export { ForwardRef as ReactComponent };